//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatConfiguredTime } from '../../../../components/helpers.js'
import { axiosPost, axiosGet } from '../../../../axios/axios.js'
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import { createFieldConfig } from '../../../../components/QSelectUtils'

import { calendarSearchParams } from './calendar.js'
import AutofillSchedule from './AutofillSchedule.vue'
import AdditionalWorkShifts from './AdditionalWorkShifts.vue'
import WorkShiftSettings from './WorkShiftSettings.vue'
import ItemsSearchField from '../../../../components/Field/ItemsSearchField.vue'
import EditBrigade from '../../sections/Brigades/Operations/EditBrigade.vue'
import DeleteBrigade from '../../sections/Brigades/Operations/DeleteBrigade.vue'

export default {
  components: {
    AutofillSchedule,
    AdditionalWorkShifts,
    WorkShiftSettings,
    ItemsSearchField
  },
  mixins: [calendarSearchParams],
  props: {
    scheduleForEdit: {
      type: Array,
      default () {
        return []
      }
    },
    scheduleOfWorker: {
      type: Array,
      default () {
        return []
      }
    },
    overtimeTariffs: {
      type: Array,
      default () {
        return []
      }
    },
    additionalOvertimeTariffs: {
      type: Array,
      default () {
        return []
      }
    },
    workShifts: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      loading: false,
      preparePropertiesFinished: false,
      selectedTab: 'editDay',

      worker: null,
      date: null,
      dates: new Set(),

      comment: null,

      projects: null,
      projectsFieldConfig: createFieldConfig({ allRecordsFn: this.getProjects }),

      redirectedWorkArea: [],
      redirected: false,

      day: {},
      dayoff: false,
      dayoffes: [
        { value: false, name: 'Рабочий' },
        { value: true, name: 'Нерабочий' }
      ],

      overtimeTariffsLocal: [],
      additionalOvertimeTariffsLocal: [],

      additionalWorkShifts: [],

      hasOvertimes: false,

      filteredWorkShifts: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    canAutofill: function () {
      if (this.redirected || !this.date || new Date(this.date).getTime() < new Date().getTime() - 1000 * 60 * 60 * 24) {
        return false
      }

      if (this.multipleDatesEdit) {
        return false
      }

      return true
    },
    multipleDatesEdit: function () {
      return [...this.dates].length > 1
    },
    readonly: function () {
      return !this.$d_hasOperation('changeEmployeeSchedule')
    },
    projectsFieldReadonly: function () {
      return this.readonly || (!this.hasOvertimes && this.additionalWorkShifts.length == 0)
    },
    canAddAdditionalWorkShift: function () {
      return !!this.worker && !this.readonly && this.additionalWorkShifts.length < 2
    },
    multipleEdit: function () {
      return !this.worker
    },
    multipleEditDaysHeader: function () {
      const typeEdit = this.selectedTab === 'editDay' ? 'Ручная настройка выбранных дней' : 'Автозаполнение расписания'
      let dates = this.formatDate(this.date)
      if (this.multipleDatesEdit) {
        dates = `(${[...this.dates].map(d => this.formatDate(d)).join(', ')})` + (this.multipleDatesEdit ? ` на основе ${this.formatDate(this.date)}` : '')
      }
      return typeEdit + ' ' + dates
    },
    textDate: {
      get: function () {
        return this.date != null ? date.formatDate(this.date, 'DD.MM.YYYY') : null
      },
      set: function (textDate) {
        this.date = textDate ? date.extractDate(textDate, 'DD.MM.YYYY').getTime() : null
      }
    }
  },
  created: function () {
    this.day = {}
    if (this.scheduleForEdit.length === 1 && this.scheduleForEdit[0].schedule.length === 1) {
      const worker = this.scheduleForEdit[0]
      this.day = this.scheduleForEdit[0].schedule[0]

      this.worker = worker
      this.redirected = worker.redirected
      this.date = worker.schedule[0].date
    } else {
      this.date = this.scheduleForEdit[0].schedule[0].date
      for (let i = 0; i < this.scheduleForEdit.length; i++) {
        const worker = this.scheduleForEdit[i]
        for (let j = 0; j < worker.schedule.length; j++) {
          const day = worker.schedule[j]
          this.dates.add(day.date)
        }
      }
    }

    this.prepareProperties()
  },
  methods: {
    prepareProperties: async function () {
      if (this.day.id || this.date && this.worker) {
        // Если редактируем один рабочий день (есть id), то загружаем по нему всю информацию (в том числе тарифы переработки)
        this.day = await this.getWorkDay(this.day)
        this.scheduleForEdit[0].schedule[0] = this.day
        this.$refs.autofillSchedule.preparAutofillRule()
      } else if (this.day.additionalWorkShifts && this.day.additionalWorkShifts.length) {
        for (let i = 0; i < this.day.additionalWorkShifts.length; i++) {
          this.day.additionalWorkShifts[i] = await this.getWorkDay(this.day.additionalWorkShifts[i])
        }
      }

      // Загружаем тарифы переработки и тарифы доп. смены для выбранных дней
      await this.getTariffs()

      this.comment = this.day.comment || null
      this.projects = this.day.projects || null
      this.redirectedWorkArea = this.day.redirectedWorkArea || []
      this.dayoff = this.day.dayoff != null ? !!this.day.dayoff : true
      this.selectedTab = 'editDay'
      this.additionalWorkShifts = this.day.additionalWorkShifts || []

      this.preparePropertiesFinished = true
    },
    parseDate: function (value) {
      const pattern = /(\d{2})-(\d{2})-(\d{4})\s(\d{2}):(\d{2}):(\d{2})/
      return new Date(value.replace(pattern, '$3-$2-$1T$4:$5:$6'))
    },
    formatDate: function (value) {
      return formatConfiguredTime(value, { year: false, month: true, date: true, hour: false, min: false, sec: false })
    },
    onSave: function (scheduleForEditLocal = null) {
      this.loading = true
      const bodyFormData = new FormData()

      if (!scheduleForEditLocal) {
        scheduleForEditLocal = JSON.parse(JSON.stringify(this.scheduleForEdit))

        for (let i = 0; i < scheduleForEditLocal.length; i++) {
          const worker = scheduleForEditLocal[i]
          for (let j = 0; j < worker.schedule.length; j++) {
            const day = worker.schedule[j]
            day.dayoff = this.dayoff
            day.comment = {
              comment: this.comment,
              time: new Date().getTime(),
              user: this.user.name
            }
            day.projects = this.projects ? this.projects.map(pr => pr.id) : []

            this.$refs.workShiftSettings.prepareWorkShiftSettingsToSave(day)

            this.additionalWorkShifts.forEach((additionalWorkShift, index) => {
              if (this.$refs.additionalWorkShifts.$refs['workShiftSettings_' + index]) {
                this.$refs.additionalWorkShifts.$refs['workShiftSettings_' + index][0].prepareWorkShiftSettingsToSave(additionalWorkShift)
              }
            })
            day.additionalWorkShifts = JSON.parse(JSON.stringify(this.additionalWorkShifts))
          }
        }
      }

      bodyFormData.set('schedule', JSON.stringify(scheduleForEditLocal))

      axiosPost({
        url: '/service/delta/workday/set',
        data: bodyFormData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Расписание отредактировано',
            progress: true,
            timeout: 3000
          })
          this.updateEmployees()
          this.onClose()
        },
        onFailure: (response) => {
          if (response.type === 'auto-connect-additional') {
            this.$d_ask({
              header: response.message,
              callback: async (data, action) => {
                if (action === 'yes') {
                  for (let i = 0; i < scheduleForEditLocal.length; i++) {
                    const worker = scheduleForEditLocal[i]
                    for (let j = 0; j < worker.schedule.length; j++) {
                      const day = worker.schedule[j]
                      day.autoConnectAdditional = true
                    }
                  }
                  this.onSave(scheduleForEditLocal)
                }
              },
              buttons: {
                yes: 'Да',
                no: 'Отмена'
              }
            })
          } else if (response.code === 'employeeHasActiveBrigade') {
            this.$d_ask({
              header: response.message,
              callback: (data, action) => {
                if (action === 'editBrigade') {
                  this.onEditDeleteBrigade(response, () => this.onSave(scheduleForEditLocal))
                } else if (action === 'delete') {
                  this.onEditDeleteBrigade(response, () => this.onSave(scheduleForEditLocal), false)
                }
              },
              buttons: [
                { key: 'editBrigade', name: 'Редактировать состав бригады', color: 'blue' },
                { key: 'delete', name: 'Расформировать бригаду', color: 'red' },
                { cancel: 'editBrigade', name: 'Отмена', color: 'white' }
              ]
            })
          } else {
            this.$q.notify({
              type: 'negative',
              message: response.message || 'Ошибка при редактировании расписания',
              progress: true,
              timeout: 8000
            })
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onEditDeleteBrigade: function (response, callback, edit = true) {
      const brigade = { id: response.brigadeId, name: response.brigadeName, date: response.date }
      const dialog = this.$d.dialog(this)
      dialog.show({
        maximized: false,
        persistent: true,
        headerHidden: true,
        contentComponent: edit ? EditBrigade : DeleteBrigade,
        contentProps: {
          brigadeId: brigade.id,
          brigade: brigade,
          date: brigade.date ? new Date(brigade.date) : null,
          onlyEditEmployees: true
        },
        componentHandlers: {
          close: function () {
            dialog.hide()
          },
          update: function () {
            dialog.hide()
            callback()
          }
        }
      })
    },
    updateEmployees: function () {
      this.$emit('employees-updated', this.scheduleForEdit.map(worker => worker.id))
    },
    onSelectDate: function (textDate) {
      this.textDate = textDate
      this.$refs.datePicker.hide()

      this.day = this.scheduleOfWorker.find(day => day.date === this.date)
      this.prepareProperties()
    },
    getWorkDay: function (day) {
      this.loading = true

      const formData = new FormData()
      let url = null
      if (day.id) {
        url = '/service/delta/workday/getemployeeworkday'
        formData.append('id', day.id)
      } else if (this.date && this.worker) {
        url = '/service/delta/workday/getemployeeworkdaybydate'

        formData.append('date', this.date)
        formData.append('employeeId', this.worker.id)
      } else {
        return Promise.resolve(day)
      }

      return axiosPost({
        url: url,
        data: formData,
        onSuccess: (response) => {
          const day = response.data
          day.comment = day.comment && day.comment.comment ? day.comment.comment : null

          if (day.dayoff) {
            day.startHour = null
            day.endHour = null
          }

          return day
        },
        onFailure: () => {
          const day = {}
          return day
        },
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    getTariffs: function () {
      this.loading = true

      const params = new URLSearchParams()

      const employeeIds = this.scheduleForEdit.map((worker) => worker.id)
      params.set('id', employeeIds)
      params.set('filter', 'none') // переведенные сотрудники отфильтровываются, поэтому отключаем фильтрацию, в данном случае смысла в ней нет

      const dates = []
      this.scheduleForEdit.forEach((worker) => {
        worker.schedule.forEach((day) => {
          if (!dates.includes(day.date)) {
            dates.push(day.date)
          }
        })
      })

      params.set('date', dates)

      return axiosGet({
        url: '/service/delta/workday/getOvertimeTariffs?' + params.toString(),
        onSuccess: (response) => {
          const matchedOvertimeTariffs = response.data.matchedOvertimeTariffs
          const matchedAdditionalOvertimeTariffs = response.data.matchedAdditionalOvertimeTariffs

          this.overtimeTariffsLocal = this.overtimeTariffs
          this.additionalOvertimeTariffsLocal = this.additionalOvertimeTariffs

          for (const worker of this.scheduleForEdit) {
            for (const day of worker.schedule) {
              const dayOvertimeTariffIds = matchedOvertimeTariffs[worker.id][day.date]
              const dayAdditionalOvertimeTariffIds = matchedAdditionalOvertimeTariffs[worker.id][day.date]

              if (dayOvertimeTariffIds) {
                this.overtimeTariffsLocal = this.overtimeTariffsLocal.filter(tariff => dayOvertimeTariffIds.includes(tariff.id))
              } else {
                this.overtimeTariffsLocal = []
              }

              if (dayAdditionalOvertimeTariffIds) {
                this.additionalOvertimeTariffsLocal = this.additionalOvertimeTariffsLocal.filter(tariff => dayAdditionalOvertimeTariffIds.includes(tariff.id))
              } else {
                this.additionalOvertimeTariffsLocal = []
              }
            }
          }
        },
        onFailure: () => {
          return []
        },
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    onClose: function () {
      this.$emit('close')
    },
    updated: function () {
      this.$emit('record-updated')
    },
    onUpdateOvertimes: function (overtimesObject) {
      this.hasOvertimes = overtimesObject.hasOvertime || overtimesObject.hasOvertimeWorkShift
    },
    onClosePopup: function (type) {
      if (type == 'start') {
        this.$refs.refPopupTimeStart.hide()
      } else if (type == 'end') {
        this.$refs.refPopupTimeEnd.hide()
      }
    },
    getProjects: function () {
      const params = [{
        param: 'status',
        type: 'listvalue',
        action: '!=',
        value: 'nonactive'
      }]
      return this.getPropertyValues('project', params)
    },
    getPropertyValues: function (propertyKey, params) {
      const encodedParams = encodeURIComponent(JSON.stringify(params))
      return axiosGet({
        url: '/service/obj/search?params=' + encodedParams + '&nameField=name&type=' + propertyKey + '&limit=1000&sort=name',
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения значений параметра ' + propertyKey
      })
    },
    getPreviousWorkShift: function (selectAdditionalWorkShift) {
      if (this.getPreviousWorkShiftOfDay(selectAdditionalWorkShift)) {
        return this.getPreviousWorkShiftOfDay(selectAdditionalWorkShift)
      } else {
        const prevDay = this.getPrevDay(this.day)
        if (prevDay) {
          return this.getPreviousWorkShiftOfDay(selectAdditionalWorkShift, prevDay, true)
        } else if (this.day.id) {
          return { id: this.day.id }
        } else {
          return null
        }
      }
    },
    getPreviousWorkShiftOfDay: function (selectAdditionalWorkShift, day = this.day, isPrevDay = false) {
      if (isPrevDay) {
        if (day && day.additionalWorkShifts && day.additionalWorkShifts.length) {
          return day.additionalWorkShifts[this.additionalWorkShifts.length - 1]
        } else if (day && day.workShift) {
          return day
        } else {
          return null
        }
      } else {
        let selectAdditionalWorkShiftIndex = -1
        if (this.additionalWorkShifts && this.additionalWorkShifts.length) {
          selectAdditionalWorkShiftIndex = this.additionalWorkShifts.findIndex(additionalWorkShift => additionalWorkShift.workShift === selectAdditionalWorkShift.key)
        }

        if (selectAdditionalWorkShiftIndex > 0) {
          return this.additionalWorkShifts[selectAdditionalWorkShiftIndex - 1]
        } else if (this.$refs.workShiftSettings.selectWorkShift && this.$refs.workShiftSettings.selectWorkShift.key) {
          const selectWorkShift = this.$refs.workShiftSettings.selectWorkShift
          return { workShift: selectWorkShift.key, date: selectWorkShift.date }
        } else {
          return null
        }
      }
    },
    getPrevDay: function (day) {
      const dayIndex = this.scheduleOfWorker.findIndex(d => d.date === day.date)
      if (dayIndex !== -1 && dayIndex > 0) {
        return this.scheduleOfWorker[dayIndex - 1]
      } else {
        return null
      }
    },
    openNextDay: function (next = true) {
      const d = new Date(this.date)
      if (next) {
        d.setDate(d.getDate() + 1)
      } else {
        d.setDate(d.getDate() - 1)
      }
      this.date = d.getTime()

      this.day = this.scheduleOfWorker.find(day => day.date === this.date) || {}
      this.prepareProperties()
    }
  }
}

